import styled from "styled-components";
import { InputLabel } from "@material-ui/core";

export const STRoot = styled.div`
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  width: 20%;
  margin-left: auto;
`;

export const STInputLabel = styled(InputLabel)`
  && {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
  }
`;
